import { useMutation } from '@apollo/client';
import type { AskSupportAssistantMutation } from '__generated__/graphql';
import { ASK_SUPPORT_ASSISTANT } from 'graphql/ai/mutations/askSupportAssistant.gql';

export type SupportCitation = NonNullable<
  AskSupportAssistantMutation['askSupportAssistant']['citations']
>[number];

export const useAskSupportAssistantMutation = () => {
  return useMutation(ASK_SUPPORT_ASSISTANT);
};
